import store from '../store';
import Communications from '../views/assistant/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/assistants',
		name: 'assistants',
		component: Communications,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
